import { NavLink } from 'react-router-dom';
import Icon from '../Icons/Icon';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand-col">
          <div className="site-footer__logo">
            <img src="/Logo 1.png" alt="Lalitpur Eye Care Logo" className="site-footer__logo-image" />
            <div className="site-footer__logo-text">
              <p className="site-footer__brand">Lalitpur Eye Care</p>
              <p className="site-footer__tagline">Your trusted eye care partner</p>
            </div>
          </div>
          <p className="site-footer__blurb">
            Comprehensive eye examinations, expert treatments, and quality
            eyewear in the heart of Jawalakhel, Lalitpur.
          </p>
          <div className="site-footer__socials" aria-label="Social links">
            <a href="https://www.facebook.com/lalitpureyecarecentre" target="_blank" rel="noreferrer" aria-label="Facebook" className="site-footer__social site-footer__social--facebook">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M14.2 8.1h2.2V4.4c-.4-.1-1.7-.2-3.2-.2-3.2 0-5.3 1.9-5.3 5.4v3H4.4v4.1h3.5V24h4.3v-7.3h3.5l.6-4.1h-4.1V10c0-1.2.3-1.9 2-1.9Z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/lalitpureyecarecenter" target="_blank" rel="noreferrer" aria-label="Instagram" className="site-footer__social site-footer__social--instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7.4 2h9.2C19.6 2 22 4.4 22 7.4v9.2c0 3-2.4 5.4-5.4 5.4H7.4C4.4 22 2 19.6 2 16.6V7.4C2 4.4 4.4 2 7.4 2Zm0 2C5.5 4 4 5.5 4 7.4v9.2C4 18.5 5.5 20 7.4 20h9.2c1.9 0 3.4-1.5 3.4-3.4V7.4C20 5.5 18.5 4 16.6 4H7.4Zm4.6 3.6a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8Zm0 2a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm4.7-2.9a1 1 0 1 1 0 2.1 1 1 0 0 1 0-2.1Z" />
              </svg>
            </a>
          </div>
        </div>

        <nav className="site-footer__col" aria-label="Shop">
          <p className="site-footer__col-title">Shop</p>
          <NavLink to="/products">Products</NavLink>
          <NavLink to="/offers">Offers</NavLink>
          <NavLink to="/getfacematching">Face Matching</NavLink>
          <NavLink to="/cart">Cart</NavLink>
        </nav>

        <nav className="site-footer__col" aria-label="Support">
          <p className="site-footer__col-title">Support</p>
          <NavLink to="/appointments">Book Appointment</NavLink>
          <NavLink to="/orders">Track Orders</NavLink>
          <NavLink to="/about">About Us</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>

        <div className="site-footer__col" aria-label="Visit us">
          <p className="site-footer__col-title">Visit Us</p>
          <p className="site-footer__info">
            <Icon name="map-pin" size={16} />
            Jawalakhel, Lalitpur
          </p>
          <p className="site-footer__info">
            <Icon name="clock" size={16} />
            Sun – Fri · 9:15 AM – 7:40 PM
          </p>
          <p className="site-footer__info">
            <a href="tel:+9779808231185">
              <Icon name="phone" size={16} />
              +977 980-8231185
            </a>
          </p>
          <p className="site-footer__info">
            <a href="mailto:lalitpureyecenter@gmail.com">
              <Icon name="mail" size={16} />
              lalitpureyecenter@gmail.com
            </a>
          </p>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>&copy; {new Date().getFullYear()} Lalitpur Eye Care. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
